import React from 'react';
import { Stack, Typography, Stepper, Step, StepLabel, IconButton } from '@mui/material';
import { theme } from '../../../theme';
import { CloseRounded, CheckCircle, CircleOutlined } from '@mui/icons-material';


function FastTrackBanner(props) {
    const hasTopDraftsReviewed = props.campaigns.every(campaign => campaign.num_top_drafts_reviewed === campaign.num_top_drafts);
    const hasOptimizationsRemaining = props.campaigns.some(campaign => campaign.num_cards_with_optimizations - campaign.num_cards_with_optimizations_reviewed > 0);
    const hasCardsRemaining = props.campaigns.some(campaign => campaign.num_drafts_reviewed - campaign.total_drafts > 0);

    function CustomIcon(props) {
        return (
            props.completed ? <CheckCircle fontSize='small' sx={{paddingLeft: '4px'}}/> : <CircleOutlined fontSize='small' sx={{paddingLeft:'4px'}}/>
        );
    }

    return (
        <Stack p={2} spacing={1} textAlign='center' sx={{ borderRadius: '4px', backgroundColor: `${theme.palette.blue.main}`, color: 'white', justifyContent: 'center'}}>
            <Stack direction='row' sx={{marginTop:'0px', alignItems: 'center'}}>
                { !hasTopDraftsReviewed &&
                    <Typography variant='normal' sx={{ fontSize: '12px', width: '100%' }}>
                        Start by reviewing your <b>Top Cards</b> at each of the locations, then go deeper!
                    </Typography>
                }
                { hasTopDraftsReviewed && hasOptimizationsRemaining &&
                    <Typography variant='normal' sx={{ fontSize: '12px', width: '100%' }}>
                        You've reviewed all <b>Top Cards</b>!
                    </Typography>
                }
                { hasTopDraftsReviewed && !hasOptimizationsRemaining && hasCardsRemaining &&
                    <Typography variant='normal' sx={{ fontSize: '12px', width: '100%' }}>
                        You've reviewed <b>All Optimizations</b>!
                    </Typography>
                }
                { hasTopDraftsReviewed && !hasOptimizationsRemaining && !hasCardsRemaining &&
                    <Typography variant='normal' sx={{ fontSize: '12px', width: '100%' }}>
                        You've reviewed <b>All Cards</b>!
                    </Typography>
                }
                <IconButton onClick={props.onClose} sx={{ color:`${theme.palette.background.white}`, padding:'0px'}}>
                    <CloseRounded fontSize='small'/>
                </IconButton>
            </Stack>
            <Stack direction='column' sx={{alignSelf: 'center'}}>
                <Stepper orientation='vertical'>
                    <Step completed={hasTopDraftsReviewed}>
                        <StepLabel StepIconComponent={CustomIcon} sx={{padding:'0px'}}>
                            <Typography variant='normal' sx={{ fontSize: '12px', color:'white'}}><em>Fast Track:</em> <b>Top Cards</b></Typography> 
                        </StepLabel>
                    </Step>
                    <Step completed={hasTopDraftsReviewed && !hasOptimizationsRemaining}>
                        <StepLabel StepIconComponent={CustomIcon} sx={{padding:'0px'}}>
                            <Typography variant='normal' sx={{ fontSize: '12px', color:'white'}}><em>Deeper Dive:</em> <b>All Optimizations</b></Typography> 
                        </StepLabel>
                    </Step>
                    <Step completed={hasTopDraftsReviewed && !hasOptimizationsRemaining && !hasCardsRemaining}>
                        <StepLabel StepIconComponent={CustomIcon} sx={{padding:'0px'}}>
                            <Typography variant='normal' sx={{ fontSize: '12px', color:'white'}}><em>In Depth:</em> <b>All Cards</b></Typography> 
                        </StepLabel>
                    </Step>
                </Stepper>
            </Stack>
        </Stack>
    );
}


export default FastTrackBanner;
